import {VetDoctor} from "./vet-clinic.model";
import {VetClinicPetSpecies} from "./vet-clinic-pet-species.model";
import {VetineoVisitTypeBundle} from "./vetineo-visit-type-bundle.model";

/**
 * Model łączący konkretny typ wizyty z Lekarzem.
 * Przechowuje zindywidualizowane ustawienia (Override), pozwalając lekarzowi mieć
 * własne ceny, czasy trwania i zasady dla globalnie zdefiniowanej usługi.
 */
export class VetDoctorVetVisitType {

  /** Globalnie unikalny identyfikator tego konkretnego przypisania. */
  public uuid: string;
  /** Identyfikator lekarza, którego dotyczy ten typ wizyty. */
  public vetDoctorUUID: string;
  /** Lekarz, którego dotyczy ten typ wizyty. */
  public vetDoctor: VetDoctor;
  /** Identyfikator klienta, którego dotyczy ten typ wizyty. */
  public vClientId: number;
  /** Vetcode lecznicy, w której zdefiniowany jest ten typ wizyty lekarza. */
  public vetcodeId: number;

  /** Klucz obcy pakietu usług, w ramach którego występuje ten obiekt. */
  public vetineoVisitTypeBundleUUID: string;
  /** Pakiet usług, w ramach którego występuje ten obiekt. */
  public vetineoVisitTypeBundle: VetineoVisitTypeBundle;
  public vetineoVetVisitTypeBundleUUID: string;

  /** Identyfikator lokalnych, lecznicowych ustawień dla tego pakietu.
   */
  public vetineoVisitTypeBundleClinicCustomSettingsUUID: string;

  /** Czy lekarz korzysta z ustawień domyślnych pakietu (true),
   * czy wprowadził własne reguły (false).
   */
  public useBundleSettings: boolean;

  /** Zindywidualizowany czas trwania wizyty u tego specjalisty. */
  public minutes: number;

  /** Flaga audytowa: Jeśli lekarz ręcznie zmienił czas trwania w swoim profilu,
   * ten przełącznik chroni jego ustawienia przed nadpisaniem.
   */
  public minutesChangedByDoctorEdit: boolean;

  /** Stosunek minutes do defaultVisitMinutes */
  public multiplier: number;

  /** Wymagana przedpłata?
   */
  public prepaidRequired: boolean;
  /** Kwota przedpłaty.
   * Ten lekarz może wymagać innej kwoty przedpłaty za tę samą usługę niż reszta zespołu.
   */
  public prepaidPrice: number;

  /** Zlokalizowana nazwa usługi. */
  public namePL: string;

  /** Dodatek do nazwy. */
  public nameAdditionPL: string;

  /** Specjalne instrukcje dla pacjenta. */
  public infoPL: string;
  public clinicName: string;

  /** Czy ta wizyta to wizyta online. */
  public online: boolean;
  /** Czy lekarz włączył dla tej usługi narzędzia komunikacyjne. */
  public communicationToolsEnabled: boolean;
  /** Czy dla tego typu wizyty włączone jest wysyłanie plików. */
  public multimediaEnabled: boolean;
  /** Czy wyświetlać czas wizyty. */
  public showMinutes: boolean;
  /** Flaga oznaczająca usługę abonamentową (Plan Opieki). */
  public isCarePlan: boolean;

  /** Czy w ramach tej usługi lekarz przyjmuje wszystkie gatunki zwierząt. */
  public allPetSpecies: boolean;
  /** Lista konkretnych gatunków, które ten lekarz obsługuje w ramach tej usługi (jeśli allPetSpecies = false). */
  public servedPetSpecies: VetClinicPetSpecies[];

  /** Czy wizytę można anulować. */
  public termCanBeCancelled: boolean;
  /** Wymuszenie podania powodu (tekstowego) przy odwoływaniu wizyty. */
  public requireCancellationReason: boolean;
  /** Maksymalny czas (w godzinach) przed wizytą, kiedy odwołanie jest jeszcze dozwolone. */
  public maxTermCancellation: number;
  /** Czas trwania usługi zaciągnięty bezpośrednio z KlinikiXP. */
  public klinikaXpVisitTypeMinutes: number;
  public created: string;
  public modified: string;

}

/**
 * Sztywny słownik (Enum) standaryzujący dopuszczalny czas trwania wizyt.
 * Gwarantuje spójność danych w bazie i zapobiega błędom UI (np. wyklikaniu wizyty
 * trwającej 17 minut). Ułatwia renderowanie list rozwijanych (Select/Dropdown).
 */
export enum VetineoVisitTypeMinutes {
  MIN5 = 5,
  MIN10 = 10,
  MIN15 = 15,
  MIN20 = 20,
  MIN25 = 25,
  MIN30 = 30,
  MIN35 = 35,
  MIN40 = 40,
  MIN45 = 45,
  MIN50 = 50,
  MIN60 = 60,
  MIN75 = 75,
  MIN80 = 80,
  MIN90 = 90,
  MIN100 = 100,
  MIN110 = 110,
  MIN120 = 120,
  MIN135 = 135,
  MIN150 = 150,
  MIN180 = 180,
  MIN195 = 195,
  MIN210 = 210,
  MIN225 = 225,
  MIN240 = 240,
  MIN255 = 255,
}
